import styled from 'styled-components';

export const Content = styled.select`
  font-family: monospace;
  width: ${(props) => props.width ?? 'auto'};
  text-align: center;
  font-size: 13px;
  border: 0;
  border-left: 1px solid #ccc;
  flex-grow: 1;
`;
